import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#049cd9',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
})

export default vuetify
